"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthVariantLookup = exports.Wrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  spacing
} = _uiKit.theme;
const widthVariantLookup = exports.widthVariantLookup = {
  NORMAL: 1366,
  NARROW: 1120
};
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "WidthWrapperstyle__Wrapper",
  componentId: "sc-17mi8u5-0"
})(["box-sizing:border-box;max-width:", "px;width:100%;margin:0 auto;height:100%;", ";", ";"], props => widthVariantLookup[props.variant], _ref => {
  let {
    withPadding
  } = _ref;
  return withPadding ? "padding: 0 ".concat(spacing.BASE_3) : '';
}, props => props.isMobile && "padding: 0;");